<template>
  <div id="cashierOrderHome">
    <div class="rightHead" style="width:100%;height:55px;">
      <img src="../../assets/icon/qrc3.png" class="qrc-logo"/>
      <span class="shopName">{{this.shopInformation.shopName}}-{{workerMaster.nickName}}</span>
    </div>
    <div class="main-container-wrapper">
      <div class="main-container">
        <div class="container-aside">
          <div style="position: relative;height: 100%;">
            <div class="shoopingCart">
              <div class="cartHead flex-between alignCenter">
                <div>结算清单({{$store.state.cartList.length}})</div>
                <div>
                  <!-- <div class="catHead-cashier">收银员：{{workerMaster.nickName}}</div> -->
                  <!-- <div class="catHead-salesman">销售员：林春城></div> -->
                  <div class="catHead-salesman">
                    <b style="font-size: 15px;">销售员:</b>
                    <el-select
                      v-if="shopWorders"
                      v-model="saleUserId"
                      placeholder="销售员"
                      size="small"
                      @change="saleEdit(selectSale)"
                      clearable
                    >
                      <el-option
                        v-for="item in shopWorders"
                        :key="item.shopWorkerUserId"
                        :label="item.fullName"
                        :value="item.shopWorkerUserId"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="cartList">
                <div class="cartListInner" v-if="this.$store.state.cartList.length !=0">
                  <div
                    class="cart-item"
                    v-for="(item,index) in this.$store.state.cartList"
                    :key="index"
                  >
                    <div class="cart-item__hd">
                      <div class="cartItemName">
                        {{item.goodsName}}
                        <span v-if="item.valueContent">({{item.valueContent}})</span>
                      </div>
                      <div class="cartItemDelete" @click.stop="delectGoods(item)">删除</div>
                    </div>
                    <div class="cart-item__sku">
                      <div
                        v-if="item.memberPrice"
                        :class="$store.state.offers.type == 4 && item.memberPrice ? 'grey-price' : 'cart-item__price' "
                        title="￥ 56.00"
                      >￥ {{item.retailPrice.toFixed(2)}}</div>
                    </div>
                    <div class="cart-item__btm">
					  <div
						v-if="item.memberPrice"
						class="pointer"
						:class="$store.state.offers.type == 4 ? 'cart-item_memberPrice' : 'cart-item_memberPrices'"
						@click="editPrice(item,item.memberPrice.toFixed(2))"
					  >会员价: ￥ {{(item.memberPrice).toFixed(2)}}</div>
					  <div
						v-if="!item.memberPrice"
						class="pointer"
						:class="$store.state.offers.type == 4 && item.memberPrice ? 'grey-price' : 'cart-item__price' "
						title="￥ 56.00"
						@click="editPrice(item,item.retailPrice.toFixed(2))"
					  >￥ {{item.retailPrice.toFixed(2)}}</div>
                      
                      <div class="cart-item__unit">{{item.goodsUnit}}</div>
                      <div class="cart-item__amount pointer" @click="editNumber(item)">x {{item.goodsNum}}</div>
                      <div
                        class="cart-item__total"
                        v-if="$store.state.offers.type == 4 && item.memberPrice"
                      >￥ {{(item.memberPrice*item.goodsNum).toFixed(2)}}</div>
                      <div
                        class="cart-item__total"
                        v-if="$store.state.offers.type !== 4"
                      >￥ {{(item.retailPrice*item.goodsNum).toFixed(2)}}</div>
                      <div
                        class="cart-item__total"
                        v-if="$store.state.offers.type == 4 && !item.memberPrice"
                      >￥ {{(item.retailPrice*item.goodsNum).toFixed(2)}}</div>
                    </div>
                  </div>
                </div>
                <div class="emptyCartList" v-if="this.$store.state.cartList.length ==0">
                  <img src="../../assets/icon/wtjsp.png" alt />
                  <div class="emptyCL-value">未添加任何商品</div>
                </div>
              </div>
              <div :class="$store.state.offers.type == 0 ? 'cartSummarys' : 'cartSummary'">
                <div class="cartSummary-discount">
                  <span class="discount-title">本单优惠</span>
                  <span
                    class="discount-ifm"
                    v-if="$store.state.offers.type == 1"
                  >优惠券满{{$store.state.offers.cashCoupon.minUsePrice}}元减{{$store.state.offers.cashCoupon.price}}元</span>
                  <span
                    class="discount-ifm"
                    v-if="$store.state.offers.type == 2"
                  >整单改价{{$store.state.offers.reducePrice}}元</span>
                  <span
                    class="discount-ifm"
                    v-if="$store.state.offers.type == 3"
                  >整单优惠{{$store.state.offers.discountNumber}}折</span>
                  <span
                    class="discount-ifm"
                    v-if="$store.state.offers.type == 4"
                  >{{$store.state.offers.vipIfms.fullName}} {{$store.state.offers.vipIfms.cardName}} {{$store.state.offers.vipIfms.discount*10}}折</span>
                  <span class="discount-val" v-if="$store.state.offers.type == 0">￥ 0.00</span>
                  <div v-if="$store.state.offers.type !== 0">
                    <!-- <span
                      class="discount-vals"
                    >￥ {{Number($store.state.cartListDiscounts).toFixed(2)}}</span>-->
                    <img :src="deleteImg" class="delete-img" @click="deleteVipIfm" />
                  </div>
                </div>
                <div class="flex-between" v-if="$store.state.offers.type !== 0">
                  <span class="discount-title">优惠金额</span>
                  <span
                    class="payNumber-val discount-val"
                  >￥ {{Number($store.state.cartListDiscounts).toFixed(2)}}</span>
                </div>
                <div class="cartSummary-payNumber flex-between">
                  <span class="payNumber-title">本单应收</span>
                  <span
                    class="payNumber-val"
                  >￥ {{Number($store.state.cartListTotalPrice).toFixed(2)}}</span>
                </div>
              </div>
            </div>
            <div class="cartActions alignCenter flex-between">
              <span>
                <span>扫码枪录入</span>
                <el-switch v-model="scanSwitch" active-color="#409EFF" inactive-color="#aaa"></el-switch>
              </span>
              <span>
                <el-button
                  class="cartActions-button"
                  style
                  type="primary"
                  @click="clearAll()"
                  plain
                >整单取消</el-button>
                <el-button class="cartActions-button" type="primary" @click="goPay">收款</el-button>
              </span>
            </div>
            <div v-show="$route.meta.showWhiteShadow" class="witeShadow"></div>
          </div>
        </div>
        <div class="container-body">
          <router-view @back="back" @open="open" ref="child"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  goodsCategoryPager,
  Shop_shopWorkers,
  workerInfo,
  shopWorkersForType
} from "../api";
export default {
  data() {
    return {
      selectSale: "", //选中销售员
      containerType: 1, //1:商品列表 2：选择规格
      todaySale: [],
      cartList: [], //购物车列表
      PageScanSwitch: false, //扫码枪录入
      tabsList: [{ categoryName: "全部", goodsTypes: "" }],
      tabsActiveId: undefined,
      searchVal: "", //搜索商品
      switchModeList: {
        switchImg: true
      },
      userList: "",
      shopInformation: "",
      commidityList: [], //商品数组
      workerMaster: {},
      shopWorders: [],
      barCode: "", //扫码枪录入码
      codeMsg: "",
      deleteImg: require("../../assets/icon/delete.png"),
      inputPattern: "",
      scanSwitch: false,
      childValue: "",
      categroyId: "",
      shopStoreId: ""
    };
  },

  computed: {
    saleUserId: {
      get() {
        return this.$store.state.saleUserId;
      },
      set(v) {
        this.$store.commit("add", v);
      }
    }
  },

  watch: {
    PageScanSwitch: function(oldValue, newValue) {
      this.addScanSwitchGoods()
    },
    scanSwitch: function(val) {
      localStorage.scanSwitchs = val
      this.PageScanSwitch = localStorage.scanSwitchs
      console.log(this.PageScanSwitch, 'this.PageScanSwitch  watch')
    }
  },

  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    // this.goodsCategoryList();
    this.workerInfo(); //查收银员
    console.log(this.$store.state.offers.type, "type");
    console.log(this.$store.state, "state");
  },

  mounted() {
    this.scanSwitch = localStorage.getItem('scanSwitchs') === "true" ? true : false
    this.PageScanSwitch = this.scanSwitch
    console.log(this.PageScanSwitch, 'mountedthis.PageScanSwitch')
  },

  methods: {
    // 调用子组件中的清空搜索内容或者分类ID，商品列表初始化
    handleClick() {
      this.$refs.child.clearContent();
    },
    // 从子组件中接收搜索内容或者分类ID
    open(val) {
      console.log(val)
      this.childValue = val
      this.categroyId = val.$attrs.id
    },
    addScanSwitchGoods() {
      if (this.PageScanSwitch == 'true') {
        document.onkeydown = e => {
          if (e.key != "Enter" && e.key != "Alt") {
            if (e.key != "Backspace") {
              if (e.key !== "Process") {
                this.codeMsg += e.key;
              }
            }
          } else if (e.key == "Enter") {
            this.barCode = this.codeMsg;
            console.log(
              this.barCode,
              this.$store.state.commidityList,
              "barCode"
            );
            if (this.childValue || this.categroyId) {
              this.handleClick()
            }
            if (this.barCode.length == 0) {
              return
            }
            var array = this.$store.state.commidityList;
            var isExist = false;
            for (let i of array) {
              console.log(i.goodsBarCode, "i.goodsBarCode")
              if (i.goodsBarCode == this.barCode) {
                isExist = true;
                var arr = i; //选择的商品
                var shoppingTrolley = this.$store.state.cartList;
                var idArr = [];
                var istrue = false; //判断选中商品是否存在购物车
                var index = null;
                for (let a of shoppingTrolley) {
                  idArr.push(a.productId);
                }
                for (let i in idArr) {
                  if (idArr[i] == arr.productId) {
                    istrue = true;
                    index = i;
                  } else {
                    // istrue = false;
                  }
                }
                if (istrue) {
                  let newGoodsNum = Number(shoppingTrolley[index].goodsNum) + 1;
                  // this.$set(shoppingTrolley[index], 'purchasingCost', this.purchasingCost)
                  this.$set(shoppingTrolley[index], "goodsNum", newGoodsNum);
                  this.$store.state.cartList = []; //直接赋值页面不刷新
                  this.$store.state.cartList = shoppingTrolley;
                } else {
                  arr.goodsNum = 1;
                  shoppingTrolley.push(arr);
                  this.$store.state.cartList = shoppingTrolley;
                }
                this.$store.commit("countTotalPrice");
                this.$store.commit("countCartListPrice");
                console.log(istrue, index, "111");
                console.log(this.shoppingTrolley);
                console.log(this.$store.state.cartList);
                console.log(this.$store.state.offers.type, '优惠类型')
                if (this.$store.state.offers.type == 2 || this.$store.state.offers.type == 3) {
                  this.deleteVipIfm()
                }
                this.$message({
                  type: "success",
                  message: "扫码录入商品" + i.goodsName,
                  duration: 1000
                });
                break;
              }
            }
            if (!isExist) {
              this.$message.error("不存在此商品");
            }
            this.codeMsg = "";
          }
        };
      } else {
        document.onkeydown = "";
      }
    },
    // 清楚优惠信息
    deleteVipIfm() {
      this.$store.state.offers.type = 0;
      this.$store.state.offers.vipIfm = [];
      let cartListTotalPrice = 0;
      this.$store.state.offers.vipIfms = {};
      for (let a of this.$store.state.cartList) {
        cartListTotalPrice += a.goodsNum * a.retailPrice;
      }
      this.$store.state.cartListTotalPrice = cartListTotalPrice.toFixed(2);
    },
    //收款
    goPay() {
      console.log(this.cartList);
      if (this.$store.state.cartList.length == 0) {
        this.$message.error("请先添加商品");
        return;
      }
      this.jumpTT("cashierOrderPay");
    },
    saleEdit(e) {
      // this.$store.state.saleUserId = e;
      console.log(this.$store.state.saleUserId, "this.$store.state.saleUserId");
    },
    jumpTT(adress) {
      this.$router.push(adress);
    },
    workerInfo(workerType) {
      workerInfo({
        sessionId: this.userList.sessionId,
        userId: this.userList.id
      })
        .then(res => {
          console.log(res.data, "店主");
          if (res.code == 1) {
            this.workerMaster = res.data;
            this.shopStoreId = this.workerMaster.shopStoreId
            this.Shop_shopWorkers(102); //查销售员
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
          }
        })
        .catch(function(error) {});
    },
    Shop_shopWorkers(workerType) {
      shopWorkersForType({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        workerType: workerType,
        pageSize: 99999, // 每页记录数
        row: 9999,
        shopStoreId: this.shopStoreId
      })
        .then(res => {
          console.log(res.data, "员工列表");
          if (res.code == 1) {
            this.shopWorders = res.data;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
          }
        })
        .catch(function(error) {});
    },
    // 整单取消
    clearAll() {
      this.$store.commit("clearCartList");
      this.$store.commit("countTotalPrice");
      this.$store.commit("countCartListPrice");
      this.$store.state.saleUserId = "";
    },
	// 修改商品价格
	editPrice(item,price) {
	  this.inputPattern = /^(([1-9]{1}[0-9]*)|([0]{1}))([.]{1}[0-9]{2})$/;
	  this.$prompt("请输入价格", "修改商品价格", {
	    confirmButtonText: "确定",
	    cancelButtonText: "取消",
	    inputPattern: this.inputPattern,
	    inputErrorMessage: "请输入正确的价格",
	    inputValue: price
	  }).then(({ value }) => {
	    var shoppingTrolley = this.$store.state.cartList;
	    for (let i in shoppingTrolley) {
	      if (shoppingTrolley[i].productId == item.productId) {
			if(shoppingTrolley[i].memberPrice){
				shoppingTrolley[i].memberPrice = parseFloat(value)
			}else{
				shoppingTrolley[i].retailPrice = parseFloat(value)
			}
			shoppingTrolley[i].discountPrice = parseFloat(value)
			console.log(shoppingTrolley, 'shoppingTrolley', parseFloat(value))
	        this.$store.state.cartList = [];
	        this.$store.state.cartList = shoppingTrolley;
	        // if (this.$store.state.offers.type == 2) {
	        //   this.$store.state.offers.type = 0;
	        //   this.$store.state.offers.reducePrice = 0;
	        // } else if (this.$store.state.offers.type == 3) {
	        //   this.$store.state.offers.type = 0;
	        //   this.$store.state.offers.discountNumber = 0;
	        // }
	        this.$store.commit("countTotalPrice");
	        this.$store.commit("countCartListPrice");
	        break;
	      }
	    }
	  });
	},
    // 修改商品数量
    editNumber(item) {
      if (item.unitType == 2) {
        this.inputPattern = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      } else if (item.unitType == 1) {
        this.inputPattern = /^[1-9]\d*$/;
      }
      this.$prompt("请输入数量", "修改商品数量", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: this.inputPattern,
        inputErrorMessage: "请输入正确的数量",
        inputValue: item.goodsNum
      }).then(({ value }) => {
        var shoppingTrolley = this.$store.state.cartList;
        console.log(shoppingTrolley, 'shoppingTrolley', value)
        for (let i in shoppingTrolley) {
          if (shoppingTrolley[i].productId == item.productId) {
            // console.log(shoppingTrolley[i]);
            if (
              item.isInfiniteStock == 0 &&
              Number(value) > item.qrcTotalStockCount
            ) {
              this.$message({
                type: "warning",
                message: "购物车选择商品库存不足"
              });
              return;
            }
            shoppingTrolley[i].goodsNum =
              Math.round(Number(value) * 1000) / 1000;
            this.$store.state.cartList = [];
            this.$store.state.cartList = shoppingTrolley;
            if (this.$store.state.offers.type == 2) {
              this.$store.state.offers.type = 0;
              this.$store.state.offers.reducePrice = 0;
            } else if (this.$store.state.offers.type == 3) {
              this.$store.state.offers.type = 0;
              this.$store.state.offers.discountNumber = 0;
            }
            this.$store.commit("countTotalPrice");
            this.$store.commit("countCartListPrice");
            break;
          }
        }
      });
    },
    // 删除商品
    delectGoods(e) {
      console.log(e);
      // this.$store.state.cartList.splice(0, 1);
      var shoppingTrolley = this.$store.state.cartList;
      console.log(shoppingTrolley, shoppingTrolley.length, "shoppingTrolley");
      // 当购物车为空时，清空优惠信息以及优惠金额的样式
      if (shoppingTrolley.length == 1) {
        this.$store.state.offers.type = 0;
        this.$store.state.offers.vipIfm = [];
      }
      // console.log(e.productId,'1')
      for (let i in shoppingTrolley) {
        if (shoppingTrolley[i].productId == e.productId) {
          shoppingTrolley.splice(i, 1);
          // console.log(i,'true')
        }
      }
      var cartListTotalPrice = 0;
      for (let a of shoppingTrolley) {
        cartListTotalPrice += a.goodsNum * a.retailPrice;
      }
      console.log(cartListTotalPrice, 111);
      this.$store.state.cartListTotalPrice = cartListTotalPrice.toFixed(2);
      console.log(this.$store.state.cartListTotalPrice);
      if (this.$store.state.takeOutCartList) {
        this.$store.state.takeOutCartList.list = shoppingTrolley;
      }
      if (this.$store.state.offers.type == 2) {
        this.$store.state.offers.type = 0;
        this.$store.state.offers.reducePrice = 0;
      } else if (this.$store.state.offers.type == 3) {
        this.$store.state.offers.type = 0;
        this.$store.state.offers.discountNumber = 0;
      }
      this.$store.commit("countTotalPrice");
      this.$store.commit("countCartListPrice");
    },
    back() {
      this.addScanSwitchGoods()
    }
  }
};
</script>

<style scoped>
.grey-price {
  color: #555;
  text-decoration: line-through;
  width: 20%;
  font-size: 12px;
}
.cart-item_memberPrice {
  width: 30%;
  color: #f92323;
  font-size: 12px;
  /* text-align: right; */
}
.cart-item_memberPrices {
  width: 32%;
  color: rgb(199, 203, 205);
  font-size: 10px;
  /* text-align: right; */
}
.emptyCL-value {
  font-size: 12px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.emptyCartList {
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.emptyCartList img {
  height: 90px;
  width: 90px;
  margin-bottom: 20px;
}
.el-select {
  width: 100px;
}
.goods-item-stocks {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 48px;
}
.goods-item-price {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(249, 35, 35, 1);
  line-height: 48px;
  margin-right: 10px;
}

.goods-item-type {
  background: #dfeffa;
  width: 50px;
  height: 24px;
  border-radius: 1px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(16, 142, 233, 1);
  line-height: 20px;
}
.goods-item-title {
  min-height: 40px;
  font-size: 14px;
  line-height: 20px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
  word-wrap: break-word;
}
.rc-goods-wrapper2 {
  position: relative;
  top: 50px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 175px));
  /* grid-template-rows: repeat(2,100px); */
  grid-gap: 20px;
}
.rc-goods-wrapper {
  position: relative;
  top: 50px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 275px));
  /* grid-template-rows: repeat(2,100px); */
  grid-gap: 20px;
}
.goods-item-img img {
  height: 100%;
  width: 100%;
}
.goods-item-img {
  height: 100%;
  width: 100px;
  display: flex;
  flex-shrink: 0;
}
.goods-item-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  padding: 10px;
  font-size: 14px;
}
.goods-item {
  position: relative;
  box-sizing: border-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  width: auto;
  height: 108px;

  overflow: hidden;
  color: #333;
  cursor: pointer;
  background-color: #f8f8f9;
  border-radius: 2px;
}
.rc-searchImg {
  height: 24px;
  width: 24px;
}
.rc-searchIcon {
  position: absolute;
  left: 10px;
  top: 7px;
}
.input__inner {
  background: #f8f8f9;
  font-size: 14px;
  color: #323233;
  background: #f8f8f9;
  caret-color: #1989fa;
  border: none;
  border-radius: 2px;
  padding: 9px 40px;
  width: 100%;
  box-sizing: border-box;
  height: 40px;
}
.rc-switchMode_icon {
  height: 27px;
  width: 29px;
  margin-bottom: 3px;
}
.rc-switchMode {
  height: 40px;
  width: 40px;
  position: absolute;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-input {
  position: absolute;
  left: 0;
  right: 40px;
}
.rc-search-wrapper {
  position: relative;
  width: 100%;
}

.rc-bottom {
  height: 64px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #eee;
  padding: 10px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(9, minmax(100px, 1fr));
  grid-template-rows: repeat(2, 1fr);
}
.rc-content::-webkit-scrollbar {
  display: none;
}
.rc-content {
  padding: 10px;
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 64px;
  overflow-x: hidden;
  overflow-y: auto;
  overflow-y: overlay;
}
.is-active::after {
  content: "";
  position: absolute;
  left: 4px;
  right: 4px;
  bottom: 0px;
  border: 1px solid #1e94ea;
}
.is-active {
  color: #1e94ea;
  font-weight: bold;
}
.rc-tabs-item {
  cursor: pointer;
  position: relative;
  display: inline-block;
  height: 100%;
  line-height: 50px;
  padding: 0 15px;
  font-size: 7px;
}
.rc-tabs-ul::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}
.rc-tabs-ul::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.rc-tabs-ul::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.rc-tabs-ul {
  position: relative;
  padding: 0;
  height: 100%;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}
li {
  list-style: none;
}
.rc-tabs {
  position: absolute;
  height: 60px;
  background-color: #eeeeee;
  top: 0;
  left: 0;
  right: 0;
}
.catHead-salesman {
  font-size: 6px;
  font-weight: 400;
  color: rgba(30, 148, 234, 1);
  margin-top: 4px;
}
.catHead-cashier {
  font-size: 6px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.cartActions-button {
  margin-left: 10px;
}

.cartSummary-payNumber {
  margin-top: 10px;
  overflow: hidden;
  clear: both;
  font-weight: bold;
}

.cartSummary-discount {
  display: flex;
  justify-content: space-between;
}
.discount-val {
  color: #f92323;
}
.discount-vals {
  color: #f92323;
  width: 100%;
  background-color: #e1effa;
  border-radius: 10px;
  padding: 4px;
  position: absolute;
  right: 38px;
  top: 13px;
}
.delete-img {
  position: relative;
  width: 24px;
  height: 24px;
  /* vertical-align: bottom; */
}

.cart-item__total {
  width: 40%;
  text-align: right;
}
.cart-item__amount {
  width: 20%;
  text-align: right;
}
.cart-item__unit {
  width: 10%;
  text-align: right;
}
.cart-item__price {
  width: 30%;
}
.cartItemDelete {
  flex-shrink: 0;
  font-size: 14px;
  line-height: 18px;
  color: #1989fa;
  cursor: pointer;
}
.cartItemName {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cart-item__btm {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 7px;
  font-size: 14px;
  line-height: 18px;
  color: #323233;
}
.cart-item__sku {
  min-height: 1em;
  margin-top: 6px;
  font-size: 12px;
  line-height: 16px;
  color: #646566;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cart-item__hd {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  font-size: 14px;
  line-height: 18px;
  color: #323233;
}
.cart-item::after {
  position: absolute;
  right: 10px;
  bottom: 0;
  left: 10px;
  height: 0;
  content: "";
  border-top: 1px dashed #dcdee0;
}
.cart-item {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 80px;
  padding: 10px 15px;
}
.pointer{
	cursor: pointer;
}
.cartSummary {
  position: absolute;
  box-sizing: border-box;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: 100%;
  box-shadow: none;
  bottom: 0;
  font-size: 14px;
  height: 100px;
  box-sizing: border-box;
  width: 100%;
  padding: 14px 17px 0 15px;
  font-size: 14px;
}
.cartSummarys {
  position: absolute;
  box-sizing: border-box;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: 100%;
  box-shadow: none;
  bottom: 0;
  font-size: 14px;
  height: 74px;
  box-sizing: border-box;
  width: 100%;
  padding: 14px 17px 0 15px;
  font-size: 14px;
}
.cartListInner {
  position: absolute;
  top: 0;
  left: 0;
  height: 90%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
.cartHead {
  padding: 0 15px;
  height: 60px;
  box-shadow: 0 1px 0 #e5e5e5;
  /* background: #eee; */
}
.cartList {
  position: absolute;
  top: 60px;
  bottom: 50px;
  left: 0;
  right: 0;
  flex-grow: 1;
  flex-shrink: 1;
  margin-bottom: 1px;
}
#cashierOrderHome {
  min-width: 800px;
  background: #f8f8f8;
  height: 100vh;
  width: 100vw;
}
.main-container-wrapper {
  position: absolute;
  top: 75px;
  right: 0;
  bottom: 20px;
  left: 0;
}

.main-container {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  min-height: 480px;
  margin: 0 20px;
}
.container-aside {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  width: 400px;
  background-color: #fff;
  box-shadow: 0 0 4px 0 rgba(195, 195, 195, 0.5);
}
.container-body {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 420px;
  background-color: #fff;
}
.shoopingCart {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 64px;
  left: 0;
}
.cartActions {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  height: 64px;
  padding: 0 15px;
  box-shadow: 0 0 4px 0 rgba(195, 195, 195, 0.5);
}
@media screen and (min-width: 1650px) {
  .main-container {
    max-width: 1600px;
    margin: 0 auto;
  }
}
@media screen and (max-width: 960px) {
  .main-container {
    margin: 0 10px;
  }
  /* .container-aside {
    width: 300px;
  } */
  /* .container-body {
    left: 310px;
  } */
}
.witeShadow {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  margin: auto;
  background: rgba(255, 255, 255, 0.7);
}
.qrc-logo {
  margin-top: 8px; 
  position: relative; 
  left: 8.5%;
  width: 120px;
  height: 35px;
}
.shopName {
  position: absolute; 
  top: 17px; 
  left: 50%
}
</style>


// WEBPACK FOOTER //
// src/components/page/cashierOrder.vue